export default "__VITE_ASSET__DZkXexV5__"